import React, { Suspense, lazy, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Buffer } from "buffer";
import FAQ from "./components/FAQ.js";
import Loading from "./components/Loading.js";

window.Buffer = window.Buffer || Buffer; // This is a workaround to allow some server-side node.js scripts to work in the browser (eg. azure-storage)

const HomePage = lazy(() => import("./pages/HomePage"));
const WaitingPage = lazy(() => import("./pages/WaitingPage"));
const ResultPage = lazy(() => import("./pages/ResultPage"));

function App() {
  const location = useLocation();
  const [showFAQ, setShowFAQ] = useState(false);

  // Either called as an onClick handler or a custom method
  function handleFaqButton(eventOrBoolean) {
    if (eventOrBoolean === false || eventOrBoolean === true) {
      setShowFAQ(eventOrBoolean);
    } else {
      setShowFAQ(!showFAQ);
    }
  }

  return (
    <div className="App">
      <Suspense fallback={<Loading />}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<HomePage />} />
          <Route path="/waiting" element={<WaitingPage />} />
          <Route path="/result" element={<ResultPage />} />
        </Routes>
      </Suspense>
      <button id="faq" onClick={handleFaqButton}>
        FAQ
      </button>
      {showFAQ && (
        <FAQ
          onClose={() => {
            handleFaqButton(false);
          }}
        />
      )}
    </div>
  );
}

export default App;
